import React, {useEffect} from 'react';
import {GridValidRowModel, GridColDef} from '@mui/x-data-grid-pro';
import {Paper} from '@mui/material';
import AutoField, {ActionType} from '../../components/AutoForm/AutoFieldNew';
import withAutoFormNew from '../../components/AutoForm/AutoFormNew';
import {OVModelsEnum} from '../../schema-types/globalTypes';
import {entityTypes} from './AuditPage';
import {useSoftDelete} from './useSoftDelete';
import {useAutoForm} from '../../components/AutoForm/useAutoForm';
import {StickyDataGrid} from '../../components/Common/StickyDataGrid';

interface SoftDeleteFormValues {
  temporaryEntityType: OVModelsEnum;
}

const columns: readonly GridColDef<GridValidRowModel>[] = [
  {
    field: 'id',
    headerName: 'ID',
    flex: 1,
  },
  {
    field: 'name',
    headerName: 'Name',
    flex: 1,
  },
  {
    field: 'dateDeleted',
    headerName: 'Date Deleted',
    flex: 1,
    valueFormatter: (val) => {
      const formattedDate = new Date(val).toLocaleDateString('en-GB');
      return formattedDate;
    },
  },
];

export const SoftDeleteForm: React.FC = () => {
  const {values} = useAutoForm<SoftDeleteFormValues>();
  const {softDeletedEntities, softDeleteData, softDeleteLoading} = useSoftDelete();

  useEffect(() => {
    if (!values.temporaryEntityType) {
      return;
    }
    softDeletedEntities({
      variables: {
        entityType: values.temporaryEntityType,
      },
    });
  }, [values.temporaryEntityType]);

  return (
    <Paper style={{padding: '1rem'}}>
      <AutoField
        field={{
          id: 'temporaryEntityType',
          type: ActionType.select,
          label: 'Entity Type',
          initialValue: undefined,
          options: entityTypes,
        }}
      />
      <StickyDataGrid
        rows={softDeleteData}
        columns={columns}
        rowHeight={60}
        loading={softDeleteLoading}
      />
    </Paper>
  );
};

const SoftDeleteFormWrapped = withAutoFormNew<SoftDeleteFormValues, object>(
  SoftDeleteForm
);

export const SoftDeletePage: React.FC = () => {
  return <SoftDeleteFormWrapped formFields={[]} />;
};
